import styled from "styled-components";
export const H2 = styled.h2`
  ${props => props.theme.typography.global};
  ${props => props.theme.typography.h2};
`;